<template>
    <el-table :data="model" row-key="key">
        <el-table-column prop="name" label="区域名称" width="120">
            <el-tooltip slot-scope="scope" :content="scope.row.description||scope.row.name">
                <span>{{scope.row.name}}</span>
            </el-tooltip>
        </el-table-column>
        <el-table-column label="区域配置">
            <el-form slot-scope="scope" label-position="left">
                <el-form-item v-for="(item,key) in scope.row.configDef" :key="key" :label="item.name" label-width="120px">
                    <el-select v-if="item.type==='field'" v-model="scope.row.configModel[key]"
                               :placeholder="item.description" @input="onConfigInput" clearable>
                        <el-option v-for="field in fields" :key="field.name" :label="field.title" :value="field.name"></el-option>
                    </el-select>
                    <el-input v-else v-model="scope.row.configModel[key]" :placeholder="item.description" @input="onConfigInput"></el-input>
                </el-form-item>
            </el-form>
        </el-table-column>
    </el-table>
</template>

<script>
    export default {
        name: "ViewStyleConfigInput",
        props: {
            value: Object,
            configTemplate: Object,
            datasource: Object
        },
        data(){
            return {
                model: this.createModel(this.value, this.configTemplate)
            }
        },
        watch:{
            value:{
                handler(){
                    this.updateModel()
                },
                deep: true
            },
            configTemplate:{
                handler(){
                    this.updateModel()
                },
                deep: true
            }
        },
        computed: {
            fields(){
                return this.datasource?this.datasource.fields:[]
            }
        },
        methods:{
            updateModel(){
                const newModel = this.createModel(this.value, this.configTemplate)
                if(JSON.stringify(newModel)!==JSON.stringify(this.model)){
                    this.model = newModel
                }
            },
            createModel(value, configTemplate){
                if(!configTemplate){
                    return []
                }
                const root = []
                const regions = []
                Object.keys(configTemplate).forEach(key=>{
                    regions.push({
                        id: key,
                        template: configTemplate[key],
                        config: value?value[key]:null,
                        model: root
                    })
                })
                let keyGen = 0
                while(regions.length>0){
                    const region = regions.shift()
                    const node = {
                        key: ++keyGen,
                        id: region.id,
                        name: region.template.name,
                        description: region.template.description,
                        configModel: Object.keys(region.template.config).reduce((model,key)=>{
                            model[key]=region.config?region.config.config[key]:null
                            return model
                        },{}),
                        configDef: Object.keys(region.template.config).reduce((def,key)=>{
                            def[key]={
                                id: key,
                                name: region.template.config[key].name,
                                description: region.template.config[key].description,
                                type: region.template.config[key].type,
                                required: region.template.config[key].required
                            }
                            return def
                        },{})
                    }
                    if(region.template.subRegions){
                        node.hasChildren = true
                        node.children = []
                        regions.push(...Object.keys(region.template.subRegions).map(key=>{
                            return {
                                id: key,
                                template: region.template.subRegions[key],
                                config: region.config?region.config.subRegionConfigs[key]:null,
                                model: node.children
                            }
                        }))
                    }else{
                        node.hasChildren = false
                    }
                    region.model.push(node)
                }
                return root
            },
            createValue(){
                const value = {}
                const queue = this.model.map(item=>{
                    return {
                        parent: value,
                        node: item
                    }
                })
                while(queue.length>0){
                    const work = queue.shift()
                    const node = {
                        config: JSON.parse(JSON.stringify(work.node.configModel)),
                    }
                    if(work.node.hasChildren){
                        node.subRegionConfigs = {}
                        queue.push(...work.node.children.map(item=>{
                            return {
                                parent: node.subRegionConfigs,
                                node: item
                            }
                        }))
                    }
                    work.parent[work.node.id]=node
                }
                return value
            },
            onConfigInput(){
                this.$emit('input', this.createValue())
            }
        }
    }
</script>

<style scoped>

</style>
